import React from 'react';
import { Box, Paper, Typography, Stack } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { formatDistanceToNow } from 'date-fns';

const DraggableGroceryItem = ({ item, currentUserId }) => {
    const { 
        attributes, 
        listeners, 
        setNodeRef, 
        transform, 
        transition,
        isDragging 
    } = useSortable({
        id: item.id,
        data: item
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    // Format timestamp
    const getTimeText = () => {
        if (item.createdAt) {
            try {
                const date = item.createdAt.toDate ? item.createdAt.toDate() : new Date(item.createdAt);
                return formatDistanceToNow(date, { addSuffix: true });
            } catch (error) {
                return '';
            }
        }
        return '';
    };

    const getUserName = (userId) => {
        if (!userId) return '';
        return userId.charAt(0).toUpperCase() + userId.slice(1);
    };

    return (
        <Paper
            ref={setNodeRef}
            style={style}
            {...listeners}
            {...attributes}
            elevation={isDragging ? 8 : 4}
            sx={{
                p: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                borderRadius: 3,
                bgcolor: '#ffffff',
                border: '2px solid #e2e8f0',
                minHeight: 100,
                cursor: isDragging ? 'grabbing' : 'grab',
                touchAction: 'none',
                '&:hover': {
                    bgcolor: '#ebf8ff',
                    transform: 'translateX(5px)',
                    boxShadow: 6,
                    borderColor: '#3182ce'
                },
                '&:active': {
                    cursor: 'grabbing'
                }
            }}
        >
            {/* Drag Handle */}
            <DragIndicatorIcon 
                sx={{ 
                    fontSize: 40, 
                    color: '#cbd5e0',
                    cursor: 'grab'
                }} 
            />

            {/* Item Content */}
            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        color: '#2d3748',
                        mb: 0.5
                    }}
                >
                    {item.name}
                </Typography>

                {/* Metadata */}
                {getTimeText() && (
                    <Typography variant="body2" sx={{ color: '#718096' }}>
                        {getTimeText()}
                    </Typography>
                )}
            </Box>
        </Paper>
    );
};

export default DraggableGroceryItem;
